import { Modifier } from 'react-popper';

const sameWidthModifier: Modifier<any, any> = {
  name: 'sameWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn({ state }: any) {
    state.styles.popper.minWidth = `${state.rects.reference.width}px`
  },
  effect({ state }: any) {
    state.elements.popper.style.minWidth = `${state.elements.reference.offsetWidth}px`
  }
}

export const AutocompleteModifiers: ReadonlyArray<Modifier<any>> = [
  sameWidthModifier,
  {
    name: "offset",
    options: {
      offset: [0, 8]
    }
  },
  {
    name: "preventOverflow",
    options: {
      boundary: "clippingParents"
    }
  },
  {
    name: "flip",
    options: {
      allowedAutoPlacements: ["bottom-end"],
      fallbackPlacements: ["bottom-end", "top-start"],
      altBoundary: true
    }
  }
]
